import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import '../../../../filters';

export default {
  name: 'AllocateInventoryItems',
  mixins: [validationMixin],
  components: {
    StoresComp: require('./../omJobcard/stores.vue').default,
    ConsumablesComp: require('./../omJobcard/consumables.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      currentPage: 'stores',
      message: '',
    }
  },
  validations: {
    maintenanceValue: {
      required
    },
  },
  created() {
    this.$root.$on('allocate_inventory_items_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
      });
    },
    gotoPage(page) {
      this.currentPage = page;
      switch (page) {
        case "stores":
          break;
        case "consumables":
          break;
        default:
        // do nothing
      }
    },
  },
  
}

